var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICalrender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3.11541,
    width: 12,
    height: 9.81818,
    rx: 1.63636,
    fill: "#D2D6DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.75177C2 3.84803 2.73262 3.11541 3.63636 3.11541H12.3636C13.2674 3.11541 14 3.84803 14 4.75177V6.38814H2V4.75177Z",
    fill: "#A2A6AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27271 4.31541V2.56995",
    stroke: "#4C5258",
    strokeWidth: 1.09091,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7273 4.31541V2.56995",
    stroke: "#4C5258",
    strokeWidth: 1.09091,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICalrender);
export default __webpack_public_path__ + "static/media/i_calrender.0ed1bef9a65ea8c2c6c35ea997f2f1bb.svg";
export { ForwardRef as ReactComponent };